@if ((card?.template?.gameplay?.type??'') === 'diagram') {
  <div class="gameplay__container__box diagram__container">
    <mat-card
      [ngClass]="{
        card__container: true,
        correct: isCorrect(),
        incorrect: !isCorrect()
      }"
    >
      <mat-card-content class="card__content">
        <ng-container [ngTemplateOutlet]="diagramTemplate"></ng-container>
      </mat-card-content>
    </mat-card>
  </div>
}

<ng-template #diagramTemplate>
  <div class="header__container">
    <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
  </div>
  <div class="choice__list__container">
    @if (questionSVG()) {
      <ng-template [ngTemplateOutlet]="_svgImage"></ng-template>
    }
  </div>
</ng-template>

<ng-template #headerTemplate>
  @if(shouldShowTopText) {
    <div
      class="header__content topText"
      [style.visibility]="!didAnswer && question?.topText ? 'visible' : 'hidden'"
      [innerHTML]="topText() | safe: 'html'"
    ></div>
  }
  @if (question?.hasText) {
    <div
      class="text__content"
      [ngClass]="didAnswer ? 'endText' : 'questionText'"
      [innerHTML]="questionText() | safe: 'html'"
    ></div>
  }
</ng-template>

<ng-template #_svgImage>
  <div
    class="svg__container"
    [@headShake]="isAnimated(chosen)"
    [inlineSVG]="questionSVG()"
    [cacheSVG]="false"
    [replaceContents]="true"
    [forceEvalStyles]="true"
    [setSVGAttributes]="setAttrs"
    [removeSVGAttributes]="delAttrs"
    (onSVGInserted)="onSVGInserted($event)"
  ></div>
</ng-template>

<ng-template #_svgImage1>
  <div class="svg__container" [@headShake]="isAnimated(chosen)">
  <gameplay-svgdiagram [url]="questionSVG()"></gameplay-svgdiagram>
  </div>
</ng-template>
